import React, { Suspense } from "react"

const StandaloneSpaceSignupFlowContainer = React.lazy(
  () =>
    import(
      "./StandaloneSpaceSignupFlowContainer" /* webpackChunkName: "StandaloneSpaceSignupFlowContainer" */
    )
)

function LazyStandaloneSpaceSignupFlowContainer(props: any) {
  return (
    <Suspense fallback={null}>
      <StandaloneSpaceSignupFlowContainer {...props} />
    </Suspense>
  )
}

export default LazyStandaloneSpaceSignupFlowContainer
